module.exports = "#error500{\n  margin-top: 15em;\n}\n"